export const createUserSiteCoreKeys = {
  userDetailKey: "PermissionAndMessages.Users.AddUserPopupHeaderAndFooter",
  coachDetailsTab: "Users.AddUserPopupHeaderAndFooter.CoachDetailsTab",
  roleDetailsTab: "Users.AddUserPopupHeaderAndFooter.RoleDetailsTab",
  userDetailsTab: "Users.AddUserPopupHeaderAndFooter.UserDetailsTab",
  powerBIReportsTab: "Users.AddUserPopupHeaderAndFooter.PowerBIReportsTab",
  viewUserHeader: "Users.AddUserPopupHeaderAndFooter.ViewUserHeader",
  userAddedToastMessage: "Users.AddUserPopup.UserAddedToastMessage",
  userDetailsUpdatedToastMessage:
    "Users.AddUserPopup.UserDetailsUpdatedToastMessage",
  editUserHeader: "Users.AddUserPopupHeaderAndFooter.EditUserHeader",
  updateUserConfirmationMessage:
    "Users.AddUserPopup.UpdateUserConfirmationMessage",
  updateUserButton: "Users.AddUserPopupHeaderAndFooter.UpdateUserButton",
  userCreatedNotUpdatedInCronofy: "Users.AddUserPopup.UserCreatedInP3AndNotUpdatedInCronofyMessage", 
  userUpdatedNotUpdatedInCronofy: "Users.AddUserPopup.UserUpdatedInP3AndNotUpdatedInCronofyMessage", 
 

  //role detail keys
  userRoleKey: "Users.AddUserPopup.RoleDetails",
  userEmail: "AddUserPopup.RoleDetails.UserEmail",
  country: "RoleDetails.LocationAccess.Country",
  serviceOffice: "RoleDetails.LocationAccess.ServiceOffice",
  firstName: "AddUserPopup.RoleDetails.FirstName",
  lastName: "AddUserPopup.RoleDetails.LastName",
  preferredNameRoleDetails: "AddUserPopup.RoleDetails.PreferredName",
  userName: "AddUserPopup.RoleDetails.UserName",
  roleDetailsLocationAccessSectionTitle:
    "AddUserPopup.RoleDetails-LocationAccessSectionTitle",
  userRolesSectionTitle: "AddUserPopup.RoleDetails.UserRolesSectionTitle",
  cirrusP3AndCandidatePortalRole:
    "RoleDetails.UserRoles.CirrusP3AndCandidatePortalRole",
  cirrusP3AndCandidatePortalSubTitle:
    "RoleDetails.UserRoles.CirrusP3AndCandidatePortalSubTitle",
  cirrusP3AndCandidatePortalAndClientPortalSubTitle:
    "RoleDetails.UserRoles.CirrusP3AndCandidatePortalAndClientPortalSubTitle",
  allRoleRadioButton: "RoleDetails.UserRoles.AllRoleRadioButton",
  cirrusP3AndCandidatePortalRoleRadioButton:
    "RoleDetails.UserRoles.CirrusP3AndCandidatePortalRoleRadioButton",
  clientPortalSubTitle: "RoleDetails.UserRoles.ClientPortalSubTitle",
  clientPortalRole: "RoleDetails.UserRoles.ClientPortalRole",
  selectedCountries: "RoleDetails.LocationAccess.SelectedCountries",
  selectedRoles: "RoleDetails.UserRoles.SelectedRoles",
  selectedServiceOffices: "RoleDetails.LocationAccess.SelectedServiceOffices",
  addUserCancelConfirmationMessage:
    "Users.AddUserPopup.AddUserCancelConfirmationMessage",
  selectedPreference: "RoleDetails.PowerBIReportAccess.SelectedPreference",
  provideAccessForPowerBIReportsCheckBoxText:
    "RoleDetails.PowerBIReportAccess.ProvideAccessForPowerBIReportsCheckBoxText",
  powerBIReportAccessSectionTitle:
    "AddUserPopup.RoleDetails.PowerBIReportAccessSectionTitle",
  coachRoleNoteMessage: "AddUserPopup.RoleDetails.CoachRoleNoteMessage",
  powerBIReportAccessNoteMessage:
    "AddUserPopup.RoleDetails.PowerBIReportAccessNoteMessage",
  coachRoleRevokeMessage: "AddUserPopup.RoleDetails.CoachRoleRevokeMessage",
  powerBIReportAccessRevokeMessage:
    "AddUserPopup.RoleDetails.PowerBIReportAccessRevokeMessage",
  coachRolePowerBIReportAccessRevokeMessage:
    "AddUserPopup.RoleDetails.CoachRolePowerBIReportAccessRevokeMessage",

  //user detail keys
  userDetailsKey: "Users.AddUserPopup.UserDetails",
  affiliateEmailId: "AddUserPopup.UserDetails.AffiliateEmailId",
  applicationLanguage: "AddUserPopup.UserDetails.ApplicationLanguage",
  homeOffice: "AddUserPopup.UserDetails.HomeOffice",
  preferredName: "AddUserPopup.UserDetails.PreferredName",
  timeZone: "AddUserPopup.UserDetails.TimeZone",
  userCountry: "AddUserPopup.UserDetails.UserCountry",
  userStatus: "AddUserPopup.UserDetails.UserStatus",
  dateFormat: "AddUserPopup.UserDetails.DateFormat",
  preferredNamePlaceHolder: "AddUserPopup.UserDetails.PreferredNamePlaceHolder",
  userEmailPlaceHolder: "AddUserPopup.UserDetails.UserEmailPlaceHolder",
  affiliateEmailIdPlaceHolder:
    "AddUserPopup.UserDetails.AffiliateEmailIdPlaceHolder",
  statusList: "AddUserPopup.UserDetails.StatusList",
  statusActive: "Status.Active",
  statusInActive: "Status.Inactive",

  //coach detail keys
  coachDetailsKey: "Users.AddUserPopup.CoachDetails",
  profileSectionTitle: "AddUserPopup.CoachDetails.ProfileSectionTitle",
  cronofySectionTitle: "AddUserPopup.CoachDetails.CronofySectionTitle",
  availableDays: "CoachDetails.Cronofy.AvailableDays",
  serviceAccountName: "CoachDetails.Cronofy.ServiceAccountName",
  coachTimeZone: "CoachDetails.Cronofy.TimeZone",
  workingHoursEndTime: "CoachDetails.Cronofy.WorkingHoursEndTime",
  workingHoursStartTime: "CoachDetails.Cronofy.WorkingHoursStartTime",
  bioData: "CoachDetails.Profile.BioData",
  coachingLanguages: "CoachDetails.Profile.CoachingLanguages",
  expertise: "CoachDetails.Profile.Expertise",
  linkedinId: "CoachDetails.Profile.LinkedinID",
  twitterId: "CoachDetails.Profile.TwitterID",
  workingHoursEndTimeList: "CoachDetails.Cronofy.WorkingHoursEndTimeList",
  workingHoursStartTimeList: "CoachDetails.Cronofy.WorkingHoursStartTimeList",
  coachingLanguagesList: "CoachDetails.Profile.CoachingLanguagesList",
  availableDaysList: "CoachDetails.Cronofy.AvailableDaysList",
  selectedCoachingLanguages: "CoachDetails.Profile.SelectedCoachingLanguages",
  selectedAvailableDays: "CoachDetails.Cronofy.SelectedAvailableDays",
  startTimeEndTimeValidationMessage:
    "CoachDetails.Cronofy.StartTimeEndTimeValidationMessage",

  //Power BI Report keys
  powerBIReportsKey: "Users.AddUserPopup.PowerBIReports",
  userEmailReport: "AddUserPopup.PowerBIReports.UserEmail",
  firstNameReport: "AddUserPopup.PowerBIReports.FirstName",
  lastNameReport: "AddUserPopup.PowerBIReports.LastName",
  accessToPowerBIReportsCancelMessage:
    "AddUserPopup.PowerBIReports.AccessToPowerBIReportsCancelMessage",
  reportAccessSection: "AddUserPopup.PowerBIReports.ReportAccessSection",
  addReport: "PowerBIReports.ReportAccessSection.AddReport",
  editReport: "PowerBIReports.ReportAccessSection.EditReport",
  reports: "PowerBIReports.ReportAccessSection.Reports",
  geoTypeList: "PowerBIReports.ReportAccessSection.GeoTypeList",
  noReportsAvailable: "PowerBIReports.ReportAccessSection.NoReportsAvailable",
  all: "PowerBIReports.ReportAccessTable.All",
  reportColumnHeader: "PowerBIReports.ReportAccessTable.Report",
  actionColumnHeader: "PowerBIReports.ReportAccessTable.Action",
  noReportsFoundMessage:
    "PowerBIReports.ReportAccessTable.NoReportsFoundMessage",
  comment: "PowerBIReports.ReportAccessSection.Comment",
  pleaseSelectAtLeastOneSalesMarketMessage:
    "PowerBIReports.ReportAccessSection.PleaseSelectAtLeastOneSalesMarketMessage",
  salesMarketIsRequiredForTheSelectedRegions:
    "PowerBIReports.ReportAccessSection.SalesMarketIsRequiredForTheSelectedRegions",
};
